// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"af58964b","274":"b67bf98a","556":"573faa57","707":"d79e12a0","774":"fec0caf9","850":"37be1a4d","895":"9e13e768"}[chunkId] + ".chunk.js";
};